import { useSuspenseQuery } from "@tanstack/react-query";
import { CustomerPortalRepository } from "../services/api/customer-portal";
import { queryClient } from "../globals";
import { useUserStore } from "../state/user_state";

export function useAccountSuspense() {
    const user = useUserStore();
    return useSuspenseQuery({
        queryKey: ["account"],
        queryFn: async () => {
            if (user.user?.tokenType === 'onetime-token') {
                return null;
            }
            const repo = CustomerPortalRepository.getInstance();
            // eslint-disable-next-line no-useless-catch
            try {
                return await repo.getAccount();
            } catch (e) {
                throw e;
            }
        },
    });
}

export function invalidateAccount() {
    return queryClient.invalidateQueries({ queryKey: ["account"] });
}